import { Theme } from "@mui/material";

const createNoteStyles = {
  headline: {
    textAlign: "center",
    fontSize: "1.25rem",
  },
  editorWrapper: (theme: Theme)=> ({
    backgroundColor: theme.palette.background.note,
  }),
  editor: {
    minHeight: "10rem",
  },
  dialogContainer: {
    padding: "1rem",
    maxWidth: 700,
  },
  checkbox: {
    color: "#137f7b",
  },
};

export default createNoteStyles;
